import { render, staticRenderFns } from "./Journey-paris.vue?vue&type=template&id=96893b98&scoped=true&"
import script from "./Journey-paris.vue?vue&type=script&lang=js&"
export * from "./Journey-paris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96893b98",
  null
  
)

export default component.exports